var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOldWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 29.5,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4999 11.6875C20.11 11.6875 11.6875 20.11 11.6875 30.4999C11.6875 40.8898 20.11 49.3125 30.4999 49.3125C40.8898 49.3125 49.3125 40.8898 49.3125 30.4999C49.3125 20.11 40.8898 11.6875 30.4999 11.6875ZM45.3589 36.7752C41.9065 44.9489 32.4817 48.7763 24.308 45.324C16.1342 41.8716 12.3068 32.4468 15.7592 24.273C19.2116 16.0993 28.6364 12.2719 36.8102 15.7243C43.8652 18.7042 47.8361 26.2497 46.2973 33.7521C46.0844 34.7881 45.7701 35.8007 45.3589 36.7752Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8139 29.9389V19.7551C31.8139 19.0136 31.2128 18.4126 30.4714 18.4126C29.73 18.4126 29.1289 19.0137 29.1289 19.7551V31.0512L37.5895 39.5118C38.1138 40.0361 38.9639 40.0361 39.4881 39.5118C40.0124 38.9876 40.0124 38.1375 39.4881 37.6132L31.8139 29.9389Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldWhite);
export default __webpack_public_path__ + "static/media/old-white.b6631ae0a8fc7f87d85a18e88d6005fb.svg";
export { ForwardRef as ReactComponent };